<template>
    <div>
        <h3>แก้ไขคนขับบิล</h3>
        <br>
        <div class="row form-group text-right">
            <div class="col-4">เลขบิลขาย</div>
            <div class="col-6">
                <input class="form-control" disabled v-model="form.invoice_id"/>
            </div>
        </div>
        <div class="row form-group text-right">
            <div class="col-4">ลูกค้า</div>
            <div class="col-6">
                <template v-if="form.customer">
                    <input class="form-control" disabled v-model="form.customer.store_name"/>
                </template>
            </div>
        </div>
        <div class="row form-group text-right">
            <div class="col-4">คนขับ</div>
            <div class="col-6">
                <multiselect
                    v-model="form.driver"
                    :options="optionDriver"
                    track-by="id"
                    :customLabel="nameWithType"
                    :show-labels="false"
                    placeholder="โปรดเลือกคนขับ">
                </multiselect>
            </div>
        </div>
        <div class="col text-center">
            <button
                type="button"
                class="btn btn-success"
                @click="submitData">
                ตกลง
            </button>
            &nbsp&nbsp
            <button
                type="button"
                class="btn btn-outline-secondary"
                @click="cancelData">
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    export default {
        name: "EditDriverModal",
        components:{
            Multiselect,
        },
        created() {
            this.$store.dispatch('Driver/getAll')
        },
        computed:{
            ...mapState({
                optionDriver:state=>{
                    return state.Driver.optionDriverInvoice;
                },
                form: state => {
                    return state.Invoice.invoiceForm;
                },
            })
        },
        methods:{
            nameWithType (option) {
                if(this.optionDriver.length > 0){
                    return `${option.name} - ${option.transport_type ? option.transport_type.name : '-'}`
                }
            },
            submitData(){
                if(!this.form.driver){
                   alert('กรุณาเลือกคนขับ');
                }else{
                    this.form.driver_id = this.form.driver.id
                    let data = {
                        invoice_id : this.form.id,
                        driver_id : this.form.driver_id,
                    }
                    this.$store.dispatch("Invoice/updateDriverInvoice",data).then(()=>{
                        this.$emit('submit',data);
                    }).catch(()=>{
                        alert('บันทึกไม่สำเร็จ');
                    })
                }
            },
            cancelData(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>
